import React from 'react';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import Button from '../../../Button';
import AddIcon from '@wix/da-ds/pkg/Icons/Add';
import PlusIconWithTextButton from '../PlusIconWithTextButton';
import withCurrentGallection from '../../_hocs/withCurrentGallection';
import submitDeviationsButtonStyles from './SubmitDeviationsButton.scss';
var enhance = compose(withCurrentGallection);
export var SubmitDeviationsButton = function (_a) {
    var buttonView = _a.buttonView, plusOnly = _a.plusOnly, currentFolderId = _a.currentFolderId;
    var t = useTranslation().t;
    return plusOnly ? (React.createElement(Button, { view: 'b3', href: URLS.SUBMIT + "?folderid=" + currentFolderId, className: submitDeviationsButtonStyles['add-button'] },
        React.createElement(AddIcon, { className: submitDeviationsButtonStyles['add-icon'] }))) : (React.createElement(PlusIconWithTextButton, { buttonView: buttonView, href: URLS.SUBMIT + "?folderid=" + currentFolderId, text: t('mediapopup.submitDeviations') }));
};
SubmitDeviationsButton.displayName = 'SubmitDeviationsButton';
export default enhance(SubmitDeviationsButton);
//# sourceMappingURL=SubmitDeviationsButton.connected.js.map